import { useDevice } from '@/hooks/useDevice'
import { SharedProps } from '@/types'
import { Link, router, usePage } from '@inertiajs/react'
import { ActionIcon, Button, Group, Menu, Text } from '@mantine/core'
import {
  IconDatabase,
  IconLayoutDashboard,
  IconLogout,
  IconScan,
  IconUserCircle,
  IconUserSquareRounded,
} from '@tabler/icons-react'

export default function TopNavbar() {
  const { current_user: user, current_organization: organization, is_super_admin } = usePage<SharedProps>().props

  const handleLogout = () => router.delete('/session')
  const { isMobile } = useDevice()

  return (
    <Group justify="space-between" align="center" style={{ flex: 1 }} wrap="nowrap">
      <Text
        component={Link}
        href={organization ? organization.comptoir_path : '/'}
        size="lg"
        fw={700}
        style={{ textDecoration: 'none', color: 'inherit', flexShrink: 0 }}
      >
        Seamflow
      </Text>

      <Group gap="xs" wrap="nowrap">
        {user ? (
          <>
            {organization?.kind_atelier && (
              <ActionIcon
                component={Link}
                href={`/organizations/${organization.slug}/scan`}
                variant={window.location.pathname.endsWith('/scan') ? 'light' : 'subtle'}
                size="lg"
                radius="md"
                style={{ flexShrink: 0 }}
              >
                <IconScan size={20} />
              </ActionIcon>
            )}
            <Menu shadow="md" width={200}>
              <Menu.Target>
                <Button variant="subtle" px={4}>
                  <Group gap={4} wrap="nowrap">
                    {isMobile ? <IconUserSquareRounded size={18} /> : <Text size="sm">{user.email}</Text>}
                    <Text size="xs" style={{ flexShrink: 0 }}>
                      ▼
                    </Text>
                  </Group>
                </Button>
              </Menu.Target>
              <Menu.Dropdown>
                {is_super_admin && (
                  <>
                    <Menu.Label>SUPER ADMIN</Menu.Label>
                    <Menu.Item component="a" href="/avo" leftSection={<IconDatabase size={16} />}>
                      Avo
                    </Menu.Item>
                    <Menu.Item component={Link} href="/admin_dashboard" leftSection={<IconLayoutDashboard size={16} />}>
                      Tableau de bord
                    </Menu.Item>
                    <Menu.Divider />
                  </>
                )}
                <Menu.Label>COMPTE</Menu.Label>
                <Menu.Item component={Link} href="/user/edit" leftSection={<IconUserCircle size={16} />}>
                  Mon compte
                </Menu.Item>
                <Menu.Item onClick={handleLogout} color="red" leftSection={<IconLogout size={16} />}>
                  Déconnecter
                </Menu.Item>
              </Menu.Dropdown>
            </Menu>
          </>
        ) : (
          <Button component={Link} href="/session/new" size="sm">
            Se connecter
          </Button>
        )}
      </Group>
    </Group>
  )
}
